import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {GenericFormService} from '../../../../core/services/generics/generic-form.service';
import {GenericDatagridService} from '../../../../core/services/generics/generic-datagrid.service';
import {UtilsService} from '../../../../core/utils/utils.service';
import {ProduitDTO} from '../../../../core/dtos/produit-dto';
import {ProduitDeclinaisonDTO} from '../../../../core/dtos/produit-declinaison-dto';
import {ProduitDeclinaisonService} from '../../../../core/services/entities/produit-declinaison.service';
import {FormGroup} from '@angular/forms';
import {FormFieldBaseSupplier} from '../../../../core/suppliers/form-fieldbase-supplier';
import {HAS_GEF, HELP_FOLDERS, MSG_KEY, MSG_SEVERITY} from '../../../../core/constants';
import {RoutemapService} from '../../../../core/services/routemap.service';
import {DialogMsgSupplier, Paragraphe} from '../../../../core/suppliers/dialog-msg-supplier';
import {Observable, Subscription} from 'rxjs';
import {GROUP_POSITION, GroupFormFields} from '../../../../core/suppliers/group-formfields';
import {ContrainteModel} from '../../../../core/models/contrainte-model';
import {ProduitDeclinaisonContrainteAlimDTO} from '../../../../core/dtos/produit-declinaison-contrainte-alim-dto';
import {cloneDeep as _cloneDeep, find as _find} from 'lodash';
import {tap} from 'rxjs/operators';
import {switchMap} from 'rxjs/internal/operators';
import {of} from 'rxjs/internal/observable/of';
import {DomSanitizer} from '@angular/platform-browser';
import {ToastService} from "../../../../core/services/technique/toast.service";
import {TextMessageService} from "../../../../shared/ui/text-messages/textMessage.service";
import {FamilleEgalimDTO} from "../../../../core/dtos/referentiel/reception/famille-egalim-dto";
import {FamilleEgalimService} from "../../../../core/services/entities/famille-egalim.service";
import {StockService} from "../../../../core/services/entities/stock-service";
import {FamilleFacturationDto} from "../../../../core/dtos/facturation/clients/famille-facturation/famille-facturation-dto";
import {FamilleFacturationService} from "../../../../core/services/entities/famille-facturation.service";
import {Auth2Service} from "../../../../core/services/security/auth2.service";
import {ButtonThemeEnum} from '../../../../shared/ui/button/button-theme-enum';

@Component({
  selector: 'yo-declinaison-produit-dialog-edit',
  templateUrl: './declinaison-produit-dialog-edit.component.html',
  styleUrls: ['./declinaison-produit-dialog-edit.component.scss'],
  standalone: false
})
export class DeclinaisonProduitDialogEditComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  @Input() denree: boolean;
  produitDeclinaison: ProduitDeclinaisonDTO;
  produit: ProduitDTO;
  fields: FormFieldBaseSupplier<any>[];
  displayDialog = false;
  private hasFacturationClient: boolean;
  manageFamilleFacturation: boolean = false;
  groups: GroupFormFields[] = [];
  form!: FormGroup<any>;
  formInfos = new FormGroup({});
  formFacturation = new FormGroup({});
  formFabrication = new FormGroup({});
  formApprovisionnement = new FormGroup({});
  formSortie = new FormGroup({});
  formEgalim = new FormGroup({});

  famillesEgalim: FamilleEgalimDTO[] = [];
  famillesFacturation: FamilleFacturationDto[] = [];

  subOpenDialog: Subscription;
  subNewUniteTechnique: Subscription;
  subFamilleEgalim: Subscription;

  deleteReponse$: Observable<boolean> = new Observable<boolean>();
  subscriptionDeletedId: Subscription;

  pathFile: string = HELP_FOLDERS.PRODUITS + '/edition-produits-declinaisons';
  allGefDefaultValues: String[] = [];
  private subFamilleFacturation: Subscription;


  constructor(
    private gfs: GenericFormService,
    private routeMapSvc: RoutemapService,
    private stockSvc: StockService,
    private produitDeclinaisonSvc: ProduitDeclinaisonService,
    private textMessageService: TextMessageService,
    public gds: GenericDatagridService,
    public domSanitizer: DomSanitizer,
    public utils: UtilsService,
    private toastSvc: ToastService,
    private familleEgalimSvc: FamilleEgalimService,
    private auth2Svc: Auth2Service,
    private familleFacturationSvc: FamilleFacturationService) {
  }

  ngOnInit() {
    this.initHasGestionFacturationClient();
    this.initFamilleFacturation();
    // ouverture du dialog
    this.openDialogSubscription();
    // abonnement à la suppression d'une déclinaison
    this.deletedIdSubscription();
    // affectation de la nouvelle unite techniue ne cas de changement
    this.subcriptionNewUniteTechnique();

    this.initFamilleEgalim();
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subscriptionDeletedId);
    this.utils.unsubscribe(this.subOpenDialog);
    this.utils.unsubscribe(this.subNewUniteTechnique);
    this.utils.unsubscribe(this.subFamilleEgalim);
    this.utils.unsubscribe(this.subFamilleFacturation);
  }

  subcriptionNewUniteTechnique = () => {
    this.subNewUniteTechnique = this.produitDeclinaisonSvc.newUniteTechnique$.subscribe(pd => {
      this.produitDeclinaison.uniteDeMesure = pd.uniteDeMesure;
      this.produitDeclinaison.ratioUniteTechnique = pd.ratioUniteTechnique;
      this.initForm(this.produit, this.produitDeclinaison);
    });
  };

  openDialogChangeUniteTechnique = (): void => {
    this.produitDeclinaisonSvc.announceOpenDialogChangeUniteTechnique(this.produitDeclinaison);
  };

  initFormDenree = (fields: FormFieldBaseSupplier<any>[], formInfos: FormGroup, formFacturation: FormGroup, formFabrication: FormGroup, formApprovisionnement: FormGroup, formSortie: FormGroup, formEgalim: FormGroup) => {
    const fieldsInfosKey = ['site', 'libelle', 'libellelong', 'declinaison', 'code', 'reference', 'codealim', 'actif'];
    const fieldsInfos = this.gfs.getFieldsByKey(fieldsInfosKey, this.fields);
    formInfos = this.gfs.toFormGroup(fieldsInfos);
    if (this.auth2Svc.hasFeature(this.auth2Svc.utilisateur, HAS_GEF)) { this.checkModifyDenreeDeclineeDeclinaison(_find(fields, {'key': 'declinaison'})); }

    const fieldsFacturationKey = ['compteComptable', 'prixDeVente', 'taxe'];

    const fieldsFacturation = this.gfs.getFieldsByKey(fieldsFacturationKey, this.fields);
    formFacturation = this.gfs.toFormGroup(fieldsFacturation);

    const fieldsFabricationKey = ['uniteDeMesure', 'ratioUniteTechnique', 'inverseRatioTechnique', 'ratioVolume'];
    const fieldsFabrication = this.gfs.getFieldsByKey(fieldsFabricationKey, this.fields);
    formFabrication = this.gfs.toFormGroup(fieldsFabrication);

    const fieldsApprovisionnementKey = ['dlc', 'zoneDeStockage', 'tacheApprovisionnement'];
    if (!this.produit.typeProduit.fabrique && !this.multiSites()) fieldsApprovisionnementKey.push('stockMinimum');

    const fieldsApprovisionnement = this.gfs.getFieldsByKey(fieldsApprovisionnementKey, this.fields);
    formApprovisionnement = this.gfs.toFormGroup(fieldsApprovisionnement);

    const fieldsSortieKey = ['tacheSortie'];
    const fieldsSortie = this.gfs.getFieldsByKey(fieldsSortieKey, this.fields);
    formSortie = this.gfs.toFormGroup(fieldsSortie);

    const fieldsEgalimKey = ['familleEgalim'];
    const fieldsEgalim = this.gfs.getFieldsByKey(fieldsEgalimKey, this.fields);
    const fieldFamilleEgalim = _find(fieldsEgalim, ['key', 'familleEgalim'])
    const selectedFamilleEgalim = _find(this.famillesEgalim, ['id', this.produitDeclinaison?.familleEgalimId])
    fieldFamilleEgalim.value = this.utils.preSelectSingleList(this.famillesEgalim, selectedFamilleEgalim)
    fieldFamilleEgalim.options = this.famillesEgalim;
    formEgalim = this.gfs.toFormGroup(fieldsEgalim);

    const groupFormFields = [
      {
        titlePanel: 'Informations',
        fields: fieldsInfos,
        form: formInfos,
        titleIcon: 'fas fa-info-circle',
        position: GROUP_POSITION.COL1,
        colsOrganization: {
          col1: fieldsInfosKey,
        }
      },
      {
        titlePanel: 'Facturation',
        fields: fieldsFacturation,
        form: formFacturation,
        titleIcon: '',
        position: GROUP_POSITION.COL2,
        colsOrganization: {
          col2: ['compteComptable', 'prixDeVente', 'taxe'],
        }
      },
      {
        titlePanel: 'Approvisionnement',
        fields: fieldsApprovisionnement,
        form: formApprovisionnement,
        titleIcon: '',
        position: GROUP_POSITION.COL1,
        colsOrganization: {
          col1: fieldsApprovisionnementKey,
        }
      },
      {
        titlePanel: 'Sortie',
        fields: fieldsSortie,
        form: formSortie,
        titleIcon: '',
        position: GROUP_POSITION.COL2,
        colsOrganization: {
          col2: fieldsSortieKey,
        }
      },
      {
        titlePanel: 'Fabrication',
        fields: fieldsFabrication,
        form: formFabrication,
        titleIcon: '',
        position: GROUP_POSITION.COL1,
        colsOrganization: {
          col1: ['uniteDeMesure', 'ratioVolume', 'ratioUniteTechnique', 'inverseRatioTechnique']
        }
      },
      {
        titlePanel: 'EGAlim',
        fields: fieldsEgalim,
        form: formEgalim,
        titleIcon: '',
        position: GROUP_POSITION.COL2,
        colsOrganization: {
          col2: fieldsEgalimKey,
        }
      },

    ];

    return {groupFormFields, formInfos, formFacturation, formFabrication, formApprovisionnement, formSortie, formEgalim};
  };

  initFormPlat = (fields: FormFieldBaseSupplier<any>[], formInfos: FormGroup, formFacturation: FormGroup, formFabrication: FormGroup) => {


    const fieldsInfosKey = ['site', 'libelle', 'declinaison', 'libellelong', 'code', 'reference', 'codealim', 'actif'];
    const fieldsInfos = this.gfs.getFieldsByKey(fieldsInfosKey, this.fields);
    formInfos = this.gfs.toFormGroup(fieldsInfos);

    const fieldsFacturationKey = ['compteComptable', 'prixDeVente', 'taxe', 'familleFacturation'];
    const fieldsFacturation = this.gfs.getFieldsByKey(fieldsFacturationKey, this.fields);
    const fieldFamilleFacturation = _find(fieldsFacturation, ['key', 'familleFacturation']);
    if (fieldFamilleFacturation) {
      const selectedFamilleFacturation = _find(this.famillesFacturation, ['id', this.produitDeclinaison?.familleFacturationId]);
      fieldFamilleFacturation.value = this.utils.preSelectSingleList(this.famillesFacturation, selectedFamilleFacturation);
      fieldFamilleFacturation.options = this.famillesFacturation;
    }
    formFacturation = this.gfs.toFormGroup(fieldsFacturation);

    const fieldsFabricationKey = ['uniteDeMesure', 'ratioUniteTechnique', 'inverseRatioTechnique', 'ratioVolume', 'dlc', 'regimes', 'tacheFabrication', 'modeOperatoire'];
    const fieldsFabrication = this.gfs.getFieldsByKey(fieldsFabricationKey, this.fields);
    formFabrication = this.gfs.toFormGroup(fieldsFabrication);

    const groupFormFields = [
      {
        titlePanel: 'Informations',
        fields: fieldsInfos,
        form: formInfos,
        titleIcon: 'fas fa-info-circle',
        position: GROUP_POSITION.COL1,
        colsOrganization: {
          col1: fieldsInfosKey,
        }
      },
      {
        titlePanel: 'Facturation',
        fields: fieldsFacturation,
        form: formFacturation,
        titleIcon: '',
        position: GROUP_POSITION.COL2,
        colsOrganization: {
          col2: fieldsFacturationKey,
        }
      },
      {
        titlePanel: 'Fabrication',
        fields: fieldsFabrication,
        form: formFabrication,
        titleIcon: '',
        position: GROUP_POSITION.COL1_AND_COL2,
        colsOrganization: {
          col1: ['uniteDeMesure', 'ratioUniteTechnique', 'inverseRatioTechnique', 'ratioVolume', 'dlc'],
          col2: ['regimes', 'tacheFabrication'],
        }
      },
    ];

    return {groupFormFields, formInfos, formFacturation, formFabrication};

  };

  /**
   * Initialiser les formulaires
   */
  initForm = (produit: ProduitDTO, produitDeclinaison: ProduitDeclinaisonDTO) => {

    this.produitDeclinaisonSvc.prepareFields(produit, produitDeclinaison).subscribe(response => {

      this.produitDeclinaison = response.produitDeclinaison;

      this.fields = response.fields;

      let formObjects = null;

      switch (this.produitDeclinaison.fabrique) {

        // PLAT
        case true:

          formObjects = this.initFormPlat(this.fields, this.formInfos, this.formFacturation, this.formFabrication);
          this.formInfos = formObjects.formInfos;
          this.formFacturation = formObjects.formFacturation;
          this.formFabrication = formObjects.formFabrication;
          this.form = new FormGroup({
            formInfos: this.formInfos,
            formFacturation: this.formFacturation,
            formFabrication: this.formFabrication
          });
          break;

        // DENREE
        case false:
          formObjects = this.initFormDenree(this.fields, this.formInfos, this.formFacturation, this.formFabrication, this.formApprovisionnement, this.formSortie, this.formEgalim);
          this.formInfos = formObjects.formInfos;
          this.formFacturation = formObjects.formFacturation;
          this.formFabrication = formObjects.formFabrication;
          this.formApprovisionnement = formObjects.formApprovisionnement;
          this.formSortie = formObjects.formSortie;
          this.formEgalim = formObjects.formEgalim;
          this.form = new FormGroup({
            formInfos: this.formInfos,
            formFacturation: this.formFacturation,
            formFabrication: this.formFabrication,
            formApprovisionnement: this.formApprovisionnement,
            formSortie: this.formSortie,
            formEgalim: this.formEgalim
          });
          break;
      }
      /*this.filterDeclinaisonAlreadyUsed(formObjects, produitDeclinaison)*/
      this.groups = formObjects.groupFormFields;
    });
  };

  /**
   Supprime de la liste de declinaisons celles qui sont déjà utilisées
   **/
  /*filterDeclinaisonAlreadyUsed = (formObjects: any, produitDeclinaison: ProduitDeclinaisonDTO) => {
    let declinaisonIdsToFilter = this.produit.produitDeclinaisons.map(pd => pd.declinaison.id)
    if (!this.isCreation(produitDeclinaison)) {
      declinaisonIdsToFilter = declinaisonIdsToFilter.filter(id => id !== produitDeclinaison.declinaison.id)
    }
    const allDeclinaisonsToSelect = formObjects.groupFormFields.filter(group => group.titlePanel === 'Informations')[0]
      .fields.filter(field => field.key === 'declinaison')[0]
      .options
    _remove(allDeclinaisonsToSelect, (declinaison: DeclinaisonDTO) => declinaisonIdsToFilter.includes(declinaison.id))
  }*/

  openDialogSubscription = () => {
    this.subOpenDialog = this.produitDeclinaisonSvc.openDialogProduitDeclinaison$
      .pipe(
        tap(data => this.displayDialog = true),
        switchMap(data => {
          this.produitDeclinaison = data.produitDeclinaison;
          this.produit = data.produit;
          this.manageFamilleFacturation = this.produit.typeProduit.fabrique && this.hasFacturationClient;
          this.allGefDefaultValues = data.allGefDefaultValues ?? [];
          this.initForm(this.produit, this.produitDeclinaison);
          return of(null);
        })
      )
      .subscribe();
  };

  deletedIdSubscription = () => {
    this.subscriptionDeletedId = this.gfs.deletedId$.subscribe((response) => {
      if (!this.utils.isResponseSupplierError(response)) {
        this.closeDialog();
      }
    });
  };

  getTitle = (produitDeclinaison: ProduitDeclinaisonDTO) => {

    if (!this.utils.isNullOrEmpty(produitDeclinaison)) {

      if (produitDeclinaison.id === 0) {
        return `<i class="fas fa-plus mg-r-5"></i>Créer une déclinaison de ${produitDeclinaison.fabrique ? 'plat' : 'denrée'}`;
      } else {
        return `<i class="fas fa-edit mg-r-5" pTooltip="Modifier la déclinaison de produit"></i> ${produitDeclinaison.libelle.toUpperCase()}`;
      }

    }

    return '';
  };

  isCreation = (produitDeclinaison: ProduitDeclinaisonDTO) => {

    if (!this.utils.isNullOrEmpty(produitDeclinaison)) {
      if (produitDeclinaison.id === 0) {
        return true;
      } else {
        return false;
      }
    }
    return true ;
  };

  help = (): DialogMsgSupplier => {
    let dms = new DialogMsgSupplier();
    dms.title = `Paramétrage d'un produit/denrée`;
    dms.logo = 'fa fa-question-circle  yoni-color';

    let p1: Paragraphe = new Paragraphe();
    p1.title = `Déclinaison d'un <b>produit/denrée</b>`;
    p1.lines = [
      `On retrouve ici des paramètres qui seront réutilisés en création de <b>plat</b> :`,
      `<ul>
<li>unité technique</li>
<li>ration entre unité technique et l’unité universelle le Kg</li>
</ul>`,
    ];

    dms.content = {
      intro: `Une <b>déclinaison</b> comporte les paramètres orientés « production ».`,
      paragraphes: [p1]
    };

    return dms;
  };


  openDeleteDialog = (produitDeclinaison: ProduitDeclinaisonDTO) => {
    const message = this.textMessageService.getProduitDeletionMessage(produitDeclinaison);
    this.gfs.openDeleteDialog(message,
      this.produitDeclinaisonSvc.getEntityName(),
      produitDeclinaison
    );
  };

  prepareSavePlat = (produitDeclinaison: ProduitDeclinaisonDTO, formInfos: FormGroup, formFacturation: FormGroup, formFabrication: FormGroup): ProduitDeclinaisonDTO => {

    // infos
    produitDeclinaison.site = formInfos.controls['site'].value;
    produitDeclinaison.libelle = formInfos.controls['libelle'].value;
    produitDeclinaison.libellelong = formInfos.controls['libellelong'].value;
    produitDeclinaison.code = formInfos.controls['code'].value;
    produitDeclinaison.reference = formInfos.controls['reference'].value;
    produitDeclinaison.actif = formInfos.controls['actif'].value;
    produitDeclinaison.declinaison = formInfos.controls['declinaison'].value;
    produitDeclinaison.codeAlim = formInfos.controls['codealim'].value;

    // facturation
    const selectedCc = formFacturation.controls['compteComptable']?.value;
    produitDeclinaison.compteComptableId = selectedCc?.id ?? null;
    produitDeclinaison.prixDeVente = formFacturation.controls['prixDeVente'].value;
    produitDeclinaison.taxe = formFacturation.controls['taxe'].value;
    const familleFacturation = formFacturation.controls['familleFacturation']?.value;
    produitDeclinaison.familleFacturationId = familleFacturation?.id ?? null;

    // fabrication
    produitDeclinaison.uniteDeMesure = formFabrication.controls['uniteDeMesure'].value;
    produitDeclinaison.ratioUniteTechnique = formFabrication.controls['ratioUniteTechnique'].value;
    produitDeclinaison.ratioVolume = formFabrication.controls['ratioVolume'].value;
    produitDeclinaison.dlc = formFabrication.controls['dlc'].value;
    produitDeclinaison.produitDeclinaisonContrainteAlimList = this.prepareSaveRegimes(formFabrication);
    const tacheFabrication = formFabrication.controls['tacheFabrication'].value;
    const ptFabrication = this.produitDeclinaisonSvc.initTacheOfProduitDeclinaison(produitDeclinaison, tacheFabrication);
    produitDeclinaison.produitDeclinaison__tacheList = [ptFabrication];

    //stock
    produitDeclinaison.zoneDeStockage = null;

    return produitDeclinaison;
  };

  prepareSaveDenree = (produitDeclinaison: ProduitDeclinaisonDTO, formInfos: FormGroup, formFacturation: FormGroup, formFabrication: FormGroup, formApprovisionnement: FormGroup, formSortie: FormGroup, formEgalim: FormGroup): ProduitDeclinaisonDTO => {


    // infos
    produitDeclinaison.site = formInfos.controls['site'].value;
    produitDeclinaison.libelle = formInfos.controls['libelle'].value;
    produitDeclinaison.libellelong = formInfos.controls['libellelong'].value;
    produitDeclinaison.code = formInfos.controls['code'].value;
    produitDeclinaison.reference = formInfos.controls['reference'].value;
    produitDeclinaison.actif = formInfos.controls['actif'].value;
    produitDeclinaison.declinaison = formInfos.controls['declinaison'].value;
    produitDeclinaison.codeAlim = formInfos.controls['codealim'].value;

    // facturation
    const selectedCc = formFacturation.controls['compteComptable']?.value;
    produitDeclinaison.compteComptableId = selectedCc?.id ?? null;
    produitDeclinaison.prixDeVente = formFacturation.controls['prixDeVente'].value;
    produitDeclinaison.taxe = formFacturation.controls['taxe'].value;

    // fabrication
    produitDeclinaison.uniteDeMesure = formFabrication.controls['uniteDeMesure'].value;
    produitDeclinaison.ratioUniteTechnique = formFabrication.controls['ratioUniteTechnique'].value;
    produitDeclinaison.ratioVolume = formFabrication.controls['ratioVolume'].value;


    // approvisionnement
    produitDeclinaison.dlc = formApprovisionnement.controls['dlc'].value;
    produitDeclinaison.zoneDeStockage = formApprovisionnement.controls['zoneDeStockage'].value;
    const tacheApprovisionnement = formApprovisionnement.controls['tacheApprovisionnement'].value;
    const pdtTacheApprovisionnement = this.produitDeclinaisonSvc.initTacheOfProduitDeclinaison(produitDeclinaison, tacheApprovisionnement);
    if (!this.multiSites()) produitDeclinaison.stockMinimum = formApprovisionnement.controls['stockMinimum'].value;
    // sortie
    const tacheSortie = formSortie.controls['tacheSortie'].value;
    const pdtTacheSortie = this.produitDeclinaisonSvc.initTacheOfProduitDeclinaison(produitDeclinaison, tacheSortie);

    // famille egalim
    const familleEgalim = formEgalim.controls['familleEgalim'].value;
    produitDeclinaison.familleEgalimId = familleEgalim.id;

    produitDeclinaison.produitDeclinaison__tacheList = [pdtTacheSortie, pdtTacheApprovisionnement];
    return produitDeclinaison;
  };

  prepareSaveRegimes = (formFabrication: FormGroup) => {

    const produitDeclinaisonContrainteAlimList: ProduitDeclinaisonContrainteAlimDTO[] = [];

    const contraintes: ContrainteModel[] = _cloneDeep(formFabrication.controls['regimes'].value);

    if (!this.utils.isNullOrEmpty(contraintes)) {
      this.produitDeclinaison.produitDeclinaisonContrainteAlimList = [];
      for (let contrainte of contraintes) {
        let contrainteDto: ProduitDeclinaisonContrainteAlimDTO = new ProduitDeclinaisonContrainteAlimDTO();
        contrainteDto.id = 0;
        contrainteDto.produitDeclinaisonLibelle = this.produitDeclinaison.libelle;
        contrainteDto.produitDeclinaisonId = this.produitDeclinaison.id;
        contrainteDto.textureId = contrainte.texture.id;
        contrainteDto.regimeId = contrainte.regime.id;
        contrainteDto.produitDeclinaisonId = 0;
        produitDeclinaisonContrainteAlimList.push(contrainteDto);
      }
    }

    return produitDeclinaisonContrainteAlimList;

  };


  /**
   * Enregistrer un produit déclinaison (plat ou denree)
   */
  saveProduitDeclinaison = () => {

    //Afficher les erreurs de validation
    this.gfs.validateAllFormFields(this.form);

    //On enregistre que si le formulaire est valide
    if (this.form.valid) {

      switch (this.produit.typeProduit.fabrique) {

        // PLAT
        case true:
          this.produitDeclinaison = this.prepareSavePlat(this.produitDeclinaison, this.formInfos, this.formFacturation, this.formFabrication);
          break;

        // DENREE
        case false:
          this.produitDeclinaison = this.prepareSaveDenree(this.produitDeclinaison, this.formInfos, this.formFacturation, this.formFabrication, this.formApprovisionnement, this.formSortie, this.formEgalim);
          break;

      }

      this.produitDeclinaisonSvc.saveProduitDeclinaison(this.produitDeclinaison).subscribe(response => {
        if (!this.utils.isResponseSupplierError(response)) {
          this.produitDeclinaisonSvc.announceSavedDTO(response);
          this.produitDeclinaison = response.one;
          this.initForm(this.produit, this.produitDeclinaison);
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `L'enregistrement de la déclinaison de produit ${this.produitDeclinaison.libelle.toUpperCase()} ${this.produitDeclinaison.declinaison.libelle.toUpperCase()} a été réalisée avec succès`);
        } else {
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, response.resultMessage);
        }

        this.routeMapSvc.goToSecondaryRoute(['gestionproduits', 'produit', this.produit.typeProduit.fabrique, this.produit.id, 'produit-declinaisons']);
      });
    }
  };

  canDelete = (produitDeclinaison: ProduitDeclinaisonDTO) => this.gds.canDelete(produitDeclinaison);

  closeDialog = () => {
    this.displayDialog = false;
  };

  initFamilleEgalim = (): void => {
    this.subFamilleEgalim = this.familleEgalimSvc.findFamillesEgalim().subscribe(response => {
      this.famillesEgalim = response;
    });
  }

  initFamilleFacturation = (): void => {
    this.subFamilleFacturation = this.familleFacturationSvc.findAllFamillesFacturation().subscribe(response => {
      this.famillesFacturation = response.allFamilleFacturation;
    });
  }

  initHasGestionFacturationClient = (): void => {
    this.auth2Svc.hasFacturationClient$.subscribe(response => this.hasFacturationClient = response);
  };
  multiSites = (): boolean => this.auth2Svc.utilisateur.siteListLocaux.length > 1;

  openGestionStockMini() {
    this.stockSvc.announceOpenGestionStockMini(this.produitDeclinaison);
  }

  /**
   * Dans le cadre de la GEF
   * Si le produit declinée possède une déclinaison définie par défaut (voir configuration GEF) alors il est possible de la modifier
   */
  private checkModifyDenreeDeclineeDeclinaison(field: FormFieldBaseSupplier<any>): void {
    if (this.allGefDefaultValues.includes(this.produitDeclinaison?.declinaison?.code)) {
      field.readonly = false;
    }
  }
}

export class DialogEditDeclinaisonProduitSupplier {
  title: string;
  logo: string;
  entityName: string = 'produitDeclinaison';
  produit: ProduitDTO;
  produitDeclinaison: ProduitDeclinaisonDTO;
  produitDeclnaisonService: ProduitDeclinaisonService;
}

